import { Link } from "react-router-dom";
import { useProducts } from "@/context/ProductsContext";
import { useSite } from "@/context/SiteContext";

export default function CollectionsGrid() {
  const { categories, loading } = useProducts();
  const { settings } = useSite();
  const h = settings.home;

  return (
    <section className="py-24 md:py-32 bg-ivory" data-testid="collections-grid">
      <div className="container-lux">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 md:mb-16 gap-6">
          <div>
            <p className="overline text-muted-foreground">{h.collections_kicker}</p>
            <h2 className="mt-4 font-serif tracking-tighter text-5xl md:text-7xl font-light">
              {h.collections_title}
            </h2>
          </div>
          <p className="max-w-md text-sm text-muted-foreground whitespace-pre-line leading-relaxed">
            {h.collections_desc}
          </p>
        </div>
      </div>

      {loading ? (
        <div
          className="grid grid-cols-2 md:grid-cols-4 gap-px bg-ivory"
          data-testid="collections-loading"
        >
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="relative aspect-[3/4] bg-muted animate-pulse" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-ivory" data-testid="collections-editorial-grid">
          {categories.map((c, i) => (
            <Link
              to={`/category/${c.slug}`}
              key={c.slug}
              className="group relative block overflow-hidden bg-muted aspect-[3/4] md:aspect-[4/5]"
              data-testid={`category-${c.slug}`}
              style={{ animationDelay: `${i * 50}ms` }}
            >
              {c.image && (
                <img
                  src={c.image}
                  loading={i < 4 ? "eager" : "lazy"}
                  fetchPriority={i < 4 ? "high" : "auto"}
                  alt={c.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.045]"
                />
              )}

              {/* Editorial image treatment inspired by luxury fashion campaign grids. */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/5 to-transparent opacity-90 transition-opacity duration-700 group-hover:opacity-100" />
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7 lg:p-8">
                <div className="flex items-end justify-between gap-3 text-ivory">
                  <span className="font-sans text-[11px] md:text-xs tracking-[0.28em] uppercase font-medium">
                    {c.name}
                  </span>
                  <span className="text-ivory/80 text-sm opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500">
                    ↗
                  </span>
                </div>
              </div>

              <span className="absolute inset-0 ring-1 ring-inset ring-black/0 group-hover:ring-ivory/30 transition-all duration-700 pointer-events-none" />
            </Link>
          ))}
        </div>
      )}

      <div className="container-lux flex justify-center mt-10 md:mt-12">
        <Link to="/collections" className="lux-link text-ink">
          View All Collections →
        </Link>
      </div>
    </section>
  );
}
